import { useQuery } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";
import type { PaidServiceUsageResponse } from "../types/paid-services.types";

/** Months shown: this one and the five before it. */
export const PAID_SERVICES_MONTHS = 6;

export function usePaidServicesUsageQuery() {
  return useQuery({
    queryKey: queryKeys.admin.paidServicesUsage(PAID_SERVICES_MONTHS),
    queryFn: () =>
      apiJsonClient<PaidServiceUsageResponse>(
        `${endpoints.admin.paidServicesUsage}?months=${PAID_SERVICES_MONTHS}`,
      ),
  });
}
